<template>
  <header
    class="sticky top-0 px-4 lg:px-6 h-20 flex items-center justify-between backdrop-blur-md bg-white/30 w-full z-50">
    <div class="flex items-center gap-4">
      <router-link to="/" class="text-2xl font-bold cursor-pointer">
        LexelUp
      </router-link>
      <img 
        src="./icons/icon.webp" 
        alt="Logo" 
        class="h-12 w-12 cursor-pointer" 
        width="48" 
        height="48" 
        @click="scrollToTop" 
      />
      <button @click="toggleMenu" class="lg:hidden" title="Menu">
        <font-awesome-icon :icon="['fas', 'bars']" class="w-6 h-6" />
      </button>
      <nav class="hidden lg:flex gap-4 sm:gap-6">
        <router-link class="text-lg font-medium hover:underline underline-offset-4" to="#about">
          About
        </router-link>
        <router-link class="text-lg font-medium hover:underline underline-offset-4" to="#features">
          Features
        </router-link>
        <router-link class="text-lg font-medium hover:underline underline-offset-4" to="#contact">
          Contact
        </router-link>
        <router-link class="text-lg font-medium hover:underline underline-offset-4" to="#pricing">
          Pricing
        </router-link>
      </nav>
    </div>
    <div class="flex items-center gap-4 sm:gap-6">
      <template v-if="isLoggedIn">
        <div class="relative" @click="toggleUserMenu">
          <div class="flex items-center justify-center w-10 h-10 rounded-full">
            <img :src="userImage" alt="User Image" class="w-10 h-10 rounded-full cursor-pointer" />
          </div>
          <div v-if="isUserMenuOpen" class="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-md py-2">
            <router-link to="/dashboard" class="block w-full text-left px-4 py-2 text-lg font-medium hover:bg-gray-100">
              Dashboard
            </router-link>
            <button @click="logout" class="block w-full text-left px-4 py-2 text-lg font-medium hover:bg-gray-100">
              Logout
            </button>
          </div>
        </div>
      </template>
      <template v-else>
        <router-link class="text-lg font-medium hover:underline underline-offset-4" to="/login">
          Login
        </router-link>
        <router-link
          class="inline-flex h-10 items-center justify-center rounded-md bg-gray-900 px-4 text-lg font-medium text-gray-50 shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50"
          to="/signup">
          Sign Up
        </router-link>
      </template>
    </div>
    <nav
      :class="{ 'lg:hidden': true, 'fixed top-20 left-0 h-[calc(100vh-5rem)] w-3/4 bg-white shadow-lg transform transition-transform duration-300 p-4 overflow-y-auto': true, '-translate-x-full': !isMenuOpen, 'translate-x-0': isMenuOpen }">
      <router-link class="block text-lg font-medium hover:underline underline-offset-4 mt-6" to="#features"
        @click="closeMenu">
        Features
      </router-link>
      <router-link class="block text-lg font-medium hover:underline underline-offset-4 mt-6" to="#about"
        @click="closeMenu">
        About
      </router-link>
      <router-link class="block text-lg font-medium hover:underline underline-offset-4 mt-6" to="#contact"
        @click="closeMenu">
        Contact
      </router-link>
      <router-link class="block text-lg font-medium hover:underline underline-offset-4 mt-6" to="#pricing"
        @click="closeMenu">
        Pricing
      </router-link>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { jwtDecode } from "jwt-decode";
import router from '@/router';
const isMenuOpen = ref(false);
const isUserMenuOpen = ref(false);
const isLoggedIn = ref(false);
const userImage = ref('');

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const closeMenu = () => {
  isMenuOpen.value = false;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const toggleUserMenu = () => {
  isUserMenuOpen.value = !isUserMenuOpen.value;
};

const logout = () => {
  localStorage.removeItem('token');
  isLoggedIn.value = false;
  router.push({path: '/', hash: ''})
};

onMounted(() => {
  isLoggedIn.value = !!localStorage.getItem('token');
  if (isLoggedIn.value) {
    const token = localStorage.getItem('token') ?? '';
    const decodedToken = jwtDecode(token);
    const username = (decodedToken as { username: string; }).username;
    if (username) {
      userImage.value = `https://api.dicebear.com/9.x/bottts-neutral/svg?seed=${username}`;
    }
  }
});
</script>

<style scoped>
/* Add any additional styles if needed */
</style>